import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/core/i18n';
import './styles/index.css';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('#root no encontrado');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
